import { SxProps, Theme, Typography } from '@mui/material'
import React from 'react'
import { TableBodyCell } from '../styled/Table.styled'

interface TextTableCellProps {
  text: string | number | undefined
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
  maxWidth?: string
  minWidth?: string
  color?: string
  textVariant?: 'subtitle1' | 'subtitle2'
  sx?: SxProps<Theme>
}

const TextTableCell: React.FC<TextTableCellProps> = ({
  text,
  align = 'left',
  maxWidth = '180px',
  minWidth,
  color = 'grey.800',
  textVariant = 'subtitle1',
  sx,
}) => {
  return (
    <TableBodyCell align={align} style={{ maxWidth, minWidth }} sx={sx}>
      <Typography noWrap variant={textVariant} color={color} fontWeight={500}>
        {text !== undefined && text !== null ? text : '-'}
      </Typography>
    </TableBodyCell>
  )
}

export default TextTableCell
